import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import MobileRightMenuSlider from "@material-ui/core/Drawer";
import {Link} from "react-router-dom";
import Footer from "./Footer";

import avatar from "../Assets/Images/avatar.png";
import logo from "../../src/logo.svg";

import {
    AppBar,
    Toolbar,
    ListItem,
    ListItemIcon,
    IconButton,
    ListItemText,
    Avatar,
    Divider,
    List,
    Typography,
    Box
} from "@material-ui/core";

import {
    ArrowBack,
    AssignmentInd,
    Home,
    Apps,
    EmojiEvents,
    AddAPhoto,
    ContactMail


} from "@material-ui/icons";

//CSS styles
const useStyles = makeStyles(theme=>({

    menuSliderContainer:{
        width: 350,
        background: "linear-gradient(270deg, rgba(255,255,255,1) 15%, rgba(186,186,186,1) 100%)",
        height: "100%",
        paddingLeft: "10px"
    },

    avatar:{
        display: "block",
        margin: "0.5rem auto",
        height: "14rem",
        width: "14rem"
    },

    logo:{
        height: "3.5rem",
        paddingRight: "4rem",
        [theme.breakpoints.down(600)]:{
            height: "2.6rem",
            paddingRight: "-10rem",
            marginLeft: "-0.9rem"
        }
    },

    arrowbackIcon:{
        color: "#1f1641",
        fontSize:"3.3rem",
        [theme.breakpoints.down(600)]:{
            height: "1.5rem",
            marginLeft: "-8.5rem"
        },
        [theme.breakpoints.down(500)]:{
            marginLeft: "-9.5rem"
        },
        [theme.breakpoints.down(400)]:{
            marginLeft: "-9.5rem"
        },
        [theme.breakpoints.down(361)]:{
            marginLeft: "-15.5rem"
        }
    },

    listItem:{
    color: "#303030",
    fontSize: "1.4rem !important",
    fontWeight: 200,
    padding: "3px",
    leftPadding:"10px"
    },

    listSpace: {
        "&:hover": {
            color: "white !important",
            background: "#fff",
            transform: "scale(1.1)"
        },
        transition: "transform 200ms ease-in-out"
    }
}));

const menuItems = [
    {
        listIcon: <Home/>,
        listText: "Home",
        listPath:"/"
    },
    {
        listIcon: <AssignmentInd/>,
        listText: "Timeline",
        listPath: "/timeline"
    },
    {
        listIcon: <Apps/>,
        listText: "Portfolio",
        listPath: "/portfolio"
    },
    {
        listIcon: <EmojiEvents/>,
        listText: "Achievements",
        listPath:"/achievements"
    },
    {
        listIcon: <AddAPhoto/>,
        listText: "Interests",
        listPath:"/interests"
    },
    {
        listIcon: <ContactMail/>,
        listText: "Contact",
        listPath: "/contact-me"
    }
];

const Navbar = () => {

    const [state, setState] = useState({
        right: false
    });

    const toggleSlider = (slider, open) => () =>{
        setState({...state, [slider]:open});
    };

    const classes = useStyles();

    const sideList = slider =>(
        <Box 
        component="div" 
        className={classes.menuSliderContainer}
        onMouseLeave={toggleSlider(slider,false)}
        >
            <a href="/" title="Pawara Siriwardhane"><Avatar src={avatar} className={classes.avatar} alt="Pawara Siriwardhane"/></a>
            <Footer/>
            <Divider/>
            <List style={{marginTop: "20px"}}>
                {menuItems.map((lsItem,key)=>(
                    <ListItem 
                        button key={key}
                        component={Link}
                        to={lsItem.listPath}
                        className={classes.listSpace}
                        title={lsItem.listText}
                        >
                        <ListItemIcon className={classes.listItem} style={{ fontSize:"1.3rem", fontWeight: 100, letterSpacing:"1px"}}>
                            {lsItem.listIcon}
                        </ListItemIcon>
                        <ListItemText 
                            disableTypography
                            primary={<Typography type="body2" style={{ fontSize:"1.3rem", fontWeight: 100, letterSpacing:"1px" }}>{lsItem.listText}</Typography>}
                            className={classes.listItem}/>
                    </ListItem>
                ))}
            </List>
        </Box>
    )

    return (
        <>
            <Box component="nav">
                <AppBar position="fixed" style={{height: "3.6rem", background: "linear-gradient(261deg, rgba(255,255,255,1) 0%, rgba(186,186,186,1) 100%)", minWidth: "480px"}}>
                    <Toolbar>
                        <Box display='flex' flexGrow={1}>
                            {/* <Typography variant="h5" style={{color:"#1f1641", cursor:"context-menu"}}> 
                                Pawara Sirwardhane
                            </Typography> */}
                            <a className="navbar-brand" href="/"><img className={classes.logo} src={logo} alt="The logo of the portfolio website of Pawara"/></a>
                        </Box>
                        <IconButton onClick={toggleSlider("right", true)} onMouseOver={toggleSlider("right", true)} >
                            <ArrowBack className={classes.arrowbackIcon} anchor="right"/>
                        </IconButton>
                        <MobileRightMenuSlider
                            anchor="right"
                            open={state.right} 
                            onClose={toggleSlider("right",false)}
                        >
                            {sideList("right")}
                        </MobileRightMenuSlider>
                    </Toolbar>
                </AppBar>
            </Box>
        </>
    );
};

export default Navbar;
